import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/css';

window.$ = $;

if (document.querySelector('.impressions-swiper')) {
    const impressionsRef = document.querySelector('.element-impressions .container');

    function getImpressionsOffset() {
        if (!impressionsRef) return 12;
        const style = getComputedStyle(impressionsRef);
        return impressionsRef.getBoundingClientRect().left + parseFloat(style.paddingLeft);
    }

    new Swiper('.impressions-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 12,
        slidesOffsetBefore: getImpressionsOffset(),
        pagination: {
            el: '.impressions-swiper .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            576: { slidesPerView: 2, spaceBetween: 16 },
            992: { slidesPerView: 2.5, spaceBetween: 24 },
        },
        on: {
            resize() {
                this.params.slidesOffsetBefore = getImpressionsOffset();
                this.update();
            }
        }
    });
}

if (document.querySelector('.news-swiper')) {
    const containerRef = document.querySelector('.element-news .container');

    function getSwiperOffset() {
        if (!containerRef) return 12;
        const style = getComputedStyle(containerRef);
        return containerRef.getBoundingClientRect().left + parseFloat(style.paddingLeft);
    }

    new Swiper('.news-swiper', {
        slidesPerView: 1.15,
        spaceBetween: 16,
        slidesOffsetBefore: getSwiperOffset(),
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            576: { slidesPerView: 2, spaceBetween: 20 },
            992: { slidesPerView: 2.5, spaceBetween: 100 },
        },
        on: {
            resize() {
                this.params.slidesOffsetBefore = getSwiperOffset();
                this.update();
            }
        }
    });
}

// faq accordion
document.querySelectorAll('.element-faq .item__heading').forEach(btn => {
    btn.addEventListener('click', () => {
        const item = btn.closest('.item');
        const isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
    });
});

// image parallax
const parallaxImg = document.querySelector('.element-image .image-parallax__bg img');
if (parallaxImg) {
    const section = parallaxImg.closest('.element-image');
    const speed = 0.3;

    const updateParallax = () => {
        const rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        parallaxImg.style.transform = `translateY(${(progress - 0.5) * speed * section.offsetHeight}px)`;
    };

    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
}

// distances animation
const distanceItems = document.querySelectorAll('.element-distances .item-row .item');
if (distanceItems.length) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    distanceItems.forEach(item => observer.observe(item));
}

// header scroll behaviour
const header = document.querySelector('header.main');
let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > 80) {
        header.classList.add('header--hidden');
    } else {
        header.classList.remove('header--hidden');
    }
    lastScrollY = currentScrollY;
}, { passive: true });

// menu
const hamburger = document.querySelector('.hamburger');
const nav = document.getElementById('nav');
const closeBtn = document.querySelector('#nav button[rel="close"]');

function openMenu() {
    nav.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
}

function closeMenu() {
    nav.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
}

hamburger?.addEventListener('click', openMenu);
closeBtn?.addEventListener('click', closeMenu);
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

// scroll to top function with jquery
$('footer button').on('click', function (optionsOrVisualDuration) {

    $('html, body').animate({ scrollTop: 0 }, optionsOrVisualDuration);


})